function ImpDescription({ product_list, productCode }) {
   if (
      product_list &&
      productCode &&
      product_list.hasOwnProperty(productCode) &&
      product_list[productCode].hasOwnProperty('ProductQuoteDesc') &&
      product_list[productCode]['ProductQuoteDesc']
   ) {
      return (
         <div className='row'>
            <div
               dangerouslySetInnerHTML={{
                  __html: product_list[productCode]['ProductQuoteDesc'],
               }}
            />
         </div>
      )
   } else {
      if (!product_list) console.error('ERROR: product_list is null')
      else if (!productCode) console.error('ERROR: productCode is null')
      else if (!product_list.hasOwnProperty(productCode))
         console.error('ERROR: Product not found in product_list')
      else if (!product_list[productCode].hasOwnProperty('ProductQuoteDesc'))
         console.error(
            'ERROR: ProductQuoteDesc not found in product_list[productCode]',
         )
      else if (!product_list[productCode]['ProductQuoteDesc'])
         console.error(
            'ERROR: ProductQuoteDesc is null in product_list[productCode]',
         )
      else console.error('ERROR: ProductDescription Unknown error')
      return null
   }
}

export default function ImpDescriptions({
   product_list,
   coreProductSelected,
   impType,
   benAdminImpType,
   payrollImpType,
   quoteType,
   dynamicProducts,
}) {
   let products = []
   if (coreProductSelected && coreProductSelected !== 'core0') {
      if (impType !== 'selfSetup' && quoteType !== 'monthly') {
         if (impType === 'quickstart')
            products.push(coreProductSelected + 'Quickstart')
         else if (impType === 'full') products.push(coreProductSelected + 'Imp')
      }
   }
   if (payrollImpType !== 'none' && quoteType !== 'monthly')
      payrollImpType === 'foundations'
         ? products.push('payrollImpFoundations')
         : products.push('payrollImp')
   if (benAdminImpType !== 'none' && quoteType !== 'monthly')
      products.push('benAdminImp')
   for (const [productCode, count] of dynamicProducts) {
      if (
         count > 0 &&
         quoteType !== 'monthly' &&
         product_list?.hasOwnProperty(productCode) &&
         product_list[productCode].hasOwnProperty('ProductQuoteDesc') &&
         product_list[productCode]['ProductQuoteDesc'] &&
         product_list[productCode]['ProductQuoteDesc'] !== '' &&
         product_list[productCode]['BillingFreq'] === 'once'
      )
         products.push(productCode)
   }

   const productDescItems = products.map((product, index) => (
      <ImpDescription
         product_list={product_list}
         productCode={product}
         key={product}
      />
   ))

   return (
      <div className='container'>
         <div className='row'>
            <div className='col-6'>
               <div className='container'>
                  {productDescItems.filter((i, idx) => !(idx % 2))}
               </div>
            </div>
            <div className='col-6'>
               <div className='container'>
                  {productDescItems.filter((i, idx) => idx % 2)}
               </div>
            </div>
         </div>
      </div>
   )
}
